const lyticsParametersWatcher = () => {
    const params = new URLSearchParams(window.location.search);
    if (!params.get('lytics')) {
        return false;
    }

    if (!params.get('type')) {
        return false;
    }

    switch (params.get('type')) {
        case 'pencilBanner':
            window.showHeaderBanner();
            break;
        case 'recipesClassics':
            window.showRecipesClassicsCard();
            break;
        case 'recommendationSlider':
            window.showRecommendationSliderCard();
            break;
        case 'signUpModal':
            if (params.get('variant') === 'a') {
                window.renderSignUpModalA();
            } else {
                window.renderSignUpModalB();
            }
            break;
        case 'homePageCopy':
            window.updateHomePageHeroCopy(params.get('segment'));
            break;
        case 'weatherNotification':
            window.showWeatherNotification(convertWeatherBug(queryStringToJSON(window.location.search.substring(1))) ?? null);
            break;

        case 'showSMSModalHomePage':
            window.showSMSModalHomePage();
            break;

        case 'showSMSModalRDP':
            window.showSMSModalRDP();
            break;

        default:
    }

    return true;
};
/**
 * This is used for testing the new modules by passing get parameters to show them.
 *
 * @returns {boolean}
 */
export const parametersWatcher = () => {

    // Run lytics parameters watcher.
    lyticsParametersWatcher();

    // General parameters watcher.
    const params = new URLSearchParams(window.location.search);

    if (Electro.DEBUG) {
        console.log(params);
    }

    switch (params.get('type')) {
        case 'weatherNotification':
            window.showWeatherNotification(convertWeatherBug(queryStringToJSON(window.location.search.substring(1))) ?? null);
            break;

        case 'showSMSModalHomePage':
            console.log('showSMSModalHomePage');
            window.showSMSModalHomePage();
            break;

        case 'showSMSModalRDP':
            window.showSMSModalRDP();
            break;

        default:
    }

    return true;
};

/**
 * Look for the source params watcher.
 *
 * Example:
 *  lytics_campaign=lyticsOct2020
 *
 * @returns {boolean}
 */
export const passSource = (leadsource, inputs) => {
    if (!leadsource || !inputs) {
        return false;
    }

    // check if it is a nodelist or singlelement.
    if (inputs.length) {
        Array.from(inputs).forEach((input) => {
            input.value = leadsource;
        });
    }

    // check if is single element.
    if (inputs instanceof Element) {
        inputs.value = leadsource;
    }
};

export const queryStringToJSON = (queryString) => {
    if(queryString.indexOf('?') > -1){
        queryString = queryString.split('?')[1];
    }
    var pairs = queryString.split('&');
    var result = {};
    pairs.forEach(function(pair) {
        pair = pair.split('=');
        result[pair[0]] = decodeURIComponent(pair[1] || '');
    });
    return result;
}

export const convertWeatherBug = (JSON) => {
    const html = {
        image: JSON.image,
        text: JSON.text,
        cta: {
            text: JSON.cta_text,
            link: JSON.cta_link,
        },
        disclaimer: {
            text1: JSON.disclaimer_text1,
            text2: JSON.disclaimer_text2,
            url: JSON.disclaimer_url
        }
    };

    return html;
}

